<c-row>
  <c-col xs="12">
    <c-card class="mb-4 shadow">
      <c-card-header ngPreserveWhitespaces>
        <c-row>
          <c-col>
            <strong>Clients</strong>
          </c-col>
        </c-row>
      </c-card-header>
      <c-card-body>
        <c-col xs="12">
          <button
            cButton
            color="primary"
            variant="outline"
            (click)="toggleModal()"
          >
            New Client
          </button>
          <c-alert
            fade
            *ngIf="msg"
            color="{{
              msg.isSuccess !== undefined
                ? msg.isSuccess
                  ? 'success'
                  : 'danger'
                : msg.IsSuccess
                ? 'success'
                : 'danger'
            }}"
            class="d-flex align-items-center mt-2"
          >
            <svg
              cIcon
              size="xl"
              name="{{
                msg.isSuccess !== undefined
                  ? msg.isSuccess
                    ? 'cilCheckCircle'
                    : 'cilWarning'
                  : msg.IsSuccess
                  ? 'cilCheckCircle'
                  : 'cilWarning'
              }}"
            ></svg>
            <div style="margin-left: 10px">
              {{ msg.Message !== undefined ? msg.Message : msg.message }}
            </div>
          </c-alert>
          <c-smart-table
            [activePage]="1"
            [columnSorter]="true"
            [columns]="UsersColumns"
            [itemsPerPageSelect]="true"
            tableFilterPlaceholder="Type Here"
            [itemsPerPage]="10"
            [items]="UsersData"
            [sorterValue]="{ column: 'name', state: 'asc' }"
            [tableFilter]="false"
            tableFilterLabel="  Search:"
            [tableProps]="{ hover: true, responsive: true }"
            [tableBodyProps]="{ align: 'middle' }"
            clickableRows
            header
            pagination
            [loading]="Loading"
            (rowClick)="OpenUserPage($event)"
          >
            <ng-template cTemplateId="tableDetails" let-item="item">
              <div
                [visible]="this.details_visible[item._id] === true"
                cCollapse
              >
                <c-card class="rounded-0">
                  <c-card-footer>
                    <div>
                      <button
                        cButton
                        class="ms-1"
                        color="primary"
                        variant="outline"
                        style="padding: 5px 10px; margin-left: 100px"
                        size="sm"
                        (click)="EditUser(item)"
                      >
                        Edit Details
                      </button>

                      <button
                        cButton
                        class="ms-1"
                        color="danger"
                        variant="outline"
                        style="padding: 5px 10px; margin-left: 100px"
                        size="sm"
                        (click)="DeleteUser(item)"
                      >
                        Delete
                      </button>
                    </div>
                  </c-card-footer>
                </c-card>
              </div>
            </ng-template>
            <ng-template
              cTemplateId="tableData"
              let-columnName="columnName"
              let-item="item"
              let-tdContent="tdContent"
            >
              <td>
                <ng-container [ngSwitch]="columnName">
                  <ng-container *ngSwitchCase="'Actions'" class="py-2">
                    <button
                      (click)="toggleDetails(item._id)"
                      cButton
                      color="primary"
                      size="sm"
                      variant="outline"
                    >
                      Actions
                    </button>
                  </ng-container>
                  <ng-container *ngSwitchCase="'productImagePath'" class="py-2">
                    <img
                      cImg
                      rounded
                      [src]="baseService.PRODUCTIMAGESURL + tdContent"
                      alt="Image"
                      class="img-fluid"
                      height="40"
                    />
                  </ng-container>
                  <ng-container *ngSwitchCase="'isActive'" class="py-2">
                    {{ tdContent ? "Active" : "Inactive" }}
                  </ng-container>
                  <ng-container *ngSwitchCase="'picture'" class="py-2">
                    <div class="text-start">
                      <app-autoavatar
                        [UserData]="item"
                        [Header]="false"
                      ></app-autoavatar>
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'CreditLimit'" class="py-2">
                    <div class="text-end">
                      {{ tdContent | currency : "$" }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchCase="'RMHID'" class="py-2">
                    <div class="text-end">
                      {{ tdContent }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    {{ tdContent }}
                  </ng-container>
                </ng-container>
              </td>
            </ng-template>
          </c-smart-table>
        </c-col>
      </c-card-body>
    </c-card>
  </c-col>
</c-row>

<!-- Add User -->
<c-modal
  #AddUser
  alignment="center"
  id="AddUser"
  size="lg"
  backdrop="static"
  [visible]="ModalVisible"
>
  <c-modal-header>
    <h5 cModalTitle>Client Details</h5>
    <button (click)="toggleModal()" cButtonClose></button>
  </c-modal-header>
  <c-modal-body>
    <form
      cForm
      #RegisterForm="ngForm"
      [validated]="customStylesValidated"
      novalidate
      class="needs-validation"
      (ngSubmit)="
        AddUserCall2(
          RegisterForm,
          UsersService.UserData,
          UsersService.UserExtraInfoData
        )
      "
    >
      <!-- <div class="text-center">
        <h3>Sign Up</h3>
        <p class="text-medium-emphasis">Register yourself as a Partner</p>
      </div> -->

      <c-row>
        <div class="text-start">
          <b class="text-medium-emphasis">Business Information</b>
        </div>
      </c-row>

      <c-row>
        <c-col lg="4">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon [cIcon]="icons.cilLibraryBuilding"></svg>
              </span>
              <input
                type="text"
                id="CompanyName"
                name="CompanyName"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.companyName"
                placeholder="Company Name"
              />
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.CompanyName.invalid &&
                          RegisterForm.controls.CompanyName.touched
                        "
                      >
                        Company Name is Required
                      </div> -->
          </div>
        </c-col>
        <c-col lg="4">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon [cIcon]="icons.cilGlobeAlt"></svg>
              </span>
              <input
                type="text"
                id="WebsiteURL"
                name="WebsiteURL"
                class="form-control"
                placeholder="Website URL"
                [(ngModel)]="UsersService.UserExtraInfoData.url"
              />
            </div>
          </div>
        </c-col>
        <c-col lg="4">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg [cIcon]="icons.cilPhone"></svg>
              </span>
              <input
                type="text"
                id="PhoneNumber"
                name="PhoneNumber"
                pattern="^[0-9\s\(\)\+\-]+$"
                (keypress)="validatePhoneNumberInput($event)"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.contactPersonPhone"
                placeholder="Phone Number"
              />
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.PhoneNumber.invalid &&
                          RegisterForm.controls.PhoneNumber.touched
                        "
                      >
                        Phone Number is Required
                      </div> -->
          </div>
        </c-col>
      </c-row>

      <c-row>
        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg [cIcon]="icons.cilBuilding"></svg>
              </span>
              <select
                id="BusinessType"
                name="BusinessType"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.businessType"
              >
              <option value="" disabled selected>
                Business Size
              </option>
              <option value="10-100">10-100 Employees</option>
              <option value="100-1000">100-1000 Employees</option>
              <option value="1000-10000">1000-10000 Employees</option>
              <option value="10000+">10000+ Employees</option>
              </select>
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.BusinessType.invalid &&
                          RegisterForm.controls.BusinessType.touched
                        "
                      >
                        Business Type is Required
                      </div> -->
          </div>
        </c-col>
        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg [cIcon]="icons.cilIndustry"></svg>
              </span>
              <select
                id="Industry"
                name="Industry"
                class="form-control"
                [(ngModel)]="UsersService.UserExtraInfoData.industry"
                required
                placeholder="Email"
              >
                <option value="" disabled selected>Industry</option>
                <option value="Accounting">Accounting</option>
                <option value="Airlines/Aviation">Airlines/Aviation</option>
                <option value="Alternative Dispute Resolution">Alternative Dispute Resolution</option>
                <option value="Alternative Medicine">Alternative Medicine</option>
                <option value="Animation">Animation</option>
                <option value="Apparel & Fashion">Apparel & Fashion</option>
                <option value="Architecture & Planning">Architecture & Planning</option>
                <option value="Arts & Crafts">Arts & Crafts</option>
                <option value="Automotive">Automotive</option>
                <option value="Aviation & Aerospace">Aviation & Aerospace</option>
                <option value="Banking">Banking</option>
                <option value="Biotechnology">Biotechnology</option>
                <option value="Broadcast Media">Broadcast Media</option>
                <option value="Building Materials">Building Materials</option>
                <option value="Business Supplies & Equipment">Business Supplies & Equipment</option>
                <option value="Capital Markets">Capital Markets</option>
                <option value="Chemicals">Chemicals</option>
                <option value="Civic & Social Organization">Civic & Social Organization</option>
                <option value="Civil Engineering">Civil Engineering</option>
                <option value="Commercial Real Estate">Commercial Real Estate</option>
                <option value="Computer & Network Security">Computer & Network Security</option>
                <option value="Computer Games">Computer Games</option>
                <option value="Computer Hardware">Computer Hardware</option>
                <option value="Computer Networking">Computer Networking</option>
                <option value="Computer Software">Computer Software</option>
                <option value="Construction">Construction</option>
                <option value="Consumer Electronics">Consumer Electronics</option>
                <option value="Consumer Goods">Consumer Goods</option>
                <option value="Consumer Services">Consumer Services</option>
                <option value="Cosmetics">Cosmetics</option>
                <option value="Dairy">Dairy</option>
                <option value="Defense & Space">Defense & Space</option>
                <option value="Design">Design</option>
                <option value="Education Management">Education Management</option>
                <option value="E-Learning">E-Learning</option>
                <option value="Electrical/Electronic Manufacturing">Electrical/Electronic Manufacturing</option>
                <option value="Entertainment">Entertainment</option>
                <option value="Environmental Services">Environmental Services</option>
                <option value="Events Services">Events Services</option>
                <option value="Executive Office">Executive Office</option>
                <option value="Facilities Services">Facilities Services</option>
                <option value="Farming">Farming</option>
                <option value="Financial Services">Financial Services</option>
                <option value="Fine Art">Fine Art</option>
                <option value="Fishery">Fishery</option>
                <option value="Food & Beverages">Food & Beverages</option>
                <option value="Food Production">Food Production</option>
                <option value="Fund-Raising">Fund-Raising</option>
                <option value="Furniture">Furniture</option>
                <option value="Gambling & Casinos">Gambling & Casinos</option>
                <option value="Glass, Ceramics & Concrete">Glass, Ceramics & Concrete</option>
                <option value="Government Administration">Government Administration</option>
                <option value="Government Relations">Government Relations</option>
                <option value="Graphic Design">Graphic Design</option>
                <option value="Health, Wellness & Fitness">Health, Wellness & Fitness</option>
                <option value="Higher Education">Higher Education</option>
                <option value="Hospital & Health Care">Hospital & Health Care</option>
                <option value="Hospitality">Hospitality</option>
                <option value="Human Resources">Human Resources</option>
                <option value="Import & Export">Import & Export</option>
                <option value="Individual & Family Services">Individual & Family Services</option>
                <option value="Industrial Automation">Industrial Automation</option>
                <option value="Information Services">Information Services</option>
                <option value="Information Technology & Services">Information Technology & Services</option>
                <option value="Insurance">Insurance</option>
                <option value="International Affairs">International Affairs</option>
                <option value="International Trade & Development">International Trade & Development</option>
                <option value="Internet">Internet</option>
                <option value="Investment Banking">Investment Banking</option>
                <option value="Investment Management">Investment Management</option>
                <option value="Judiciary">Judiciary</option>
                <option value="Law Enforcement">Law Enforcement</option>
                <option value="Law Practice">Law Practice</option>
                <option value="Legal Services">Legal Services</option>
                <option value="Legislative Office">Legislative Office</option>
                <option value="Leisure, Travel & Tourism">Leisure, Travel & Tourism</option>
                <option value="Libraries">Libraries</option>
                <option value="Logistics & Supply Chain">Logistics & Supply Chain</option>
                <option value="Luxury Goods & Jewelry">Luxury Goods & Jewelry</option>
                <option value="Machinery">Machinery</option>
                <option value="Management Consulting">Management Consulting</option>
                <option value="Maritime">Maritime</option>
                <option value="Market Research">Market Research</option>
                <option value="Marketing & Advertising">Marketing & Advertising</option>
                <option value="Mechanical or Industrial Engineering">Mechanical or Industrial Engineering</option>
                <option value="Media Production">Media Production</option>
                <option value="Medical Device">Medical Device</option>
                <option value="Medical Practice">Medical Practice</option>
                <option value="Mental Health Care">Mental Health Care</option>
                <option value="Military">Military</option>
                <option value="Mining & Metals">Mining & Metals</option>
                <option value="Motion Pictures & Film">Motion Pictures & Film</option>
                <option value="Museums & Institutions">Museums & Institutions</option>
                <option value="Music">Music</option>
                <option value="Nanotechnology">Nanotechnology</option>
                <option value="Newspapers">Newspapers</option>
                <option value="Non-Profit Organization Management">Non-Profit Organization Management</option>
                <option value="Oil & Energy">Oil & Energy</option>
                <option value="Online Media">Online Media</option>
                <option value="Outsourcing/Offshoring">Outsourcing/Offshoring</option>
                <option value="Package/Freight Delivery">Package/Freight Delivery</option>
                <option value="Packaging & Containers">Packaging & Containers</option>
                <option value="Paper & Forest Products">Paper & Forest Products</option>
                <option value="Performing Arts">Performing Arts</option>
                <option value="Pharmaceuticals">Pharmaceuticals</option>
                <option value="Philanthropy">Philanthropy</option>
                <option value="Photography">Photography</option>
                <option value="Plastics">Plastics</option>
                <option value="Political Organization">Political Organization</option>
                <option value="Primary/Secondary Education">Primary/Secondary Education</option>
                <option value="Printing">Printing</option>
                <option value="Professional Training & Coaching">Professional Training & Coaching</option>
                <option value="Program Development">Program Development</option>
                <option value="Public Policy">Public Policy</option>
                <option value="Public Relations & Communications">Public Relations & Communications</option>
                <option value="Public Safety">Public Safety</option>
                <option value="Publishing">Publishing</option>
                <option value="Railroad Manufacture">Railroad Manufacture</option>
                <option value="Ranching">Ranching</option>
                <option value="Real Estate">Real Estate</option>
                <option value="Recreational Facilities & Services">Recreational Facilities & Services</option>
                <option value="Religious Institutions">Religious Institutions</option>
                <option value="Renewables & Environment">Renewables & Environment</option>
                <option value="Research">Research</option>
                <option value="Restaurants">Restaurants</option>
                <option value="Retail">Retail</option>
                <option value="Security & Investigations">Security & Investigations</option>
                <option value="Semiconductors">Semiconductors</option>
                <option value="Shipbuilding">Shipbuilding</option>
                <option value="Sporting Goods">Sporting Goods</option>
                <option value="Sports">Sports</option>
                <option value="Staffing & Recruiting">Staffing & Recruiting</option>
                <option value="Supermarkets">Supermarkets</option>
                <option value="Telecommunications">Telecommunications</option>
                <option value="Textiles">Textiles</option>
                <option value="Think Tanks">Think Tanks</option>
                <option value="Tobacco">Tobacco</option>
                <option value="Translation & Localization">Translation & Localization</option>
                <option value="Transportation/Trucking/Railroad">Transportation/Trucking/Railroad</option>
                <option value="Utilities">Utilities</option>
                <option value="Venture Capital & Private Equity">Venture Capital & Private Equity</option>
                <option value="Veterinary">Veterinary</option>
                <option value="Warehousing">Warehousing</option>
                <option value="Wholesale">Wholesale</option>
                <option value="Wine & Spirits">Wine & Spirits</option>
                <option value="Wireless">Wireless</option>
                <option value="Writing & Editing">Writing & Editing</option>
              </select>
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.Industry.invalid &&
                          RegisterForm.controls.Industry.touched
                        "
                      >
                        Industry is Required
                      </div> -->
          </div>
        </c-col>
      </c-row>

      <!-- <c-row>
                  <c-col lg="6">
                    <div class="mb-3">
                      <div class="input-group">
                        <span class="input-group-text">
                          <svg cIcon [cIcon]="icons.cilMobile"></svg>
                        </span>
                        <input
                          type="text"
                          id="Mobile"
                          name="Mobile"
                          [(ngModel)]="
                            UsersService.UserData.mobilePhoneNumber
                          "
                          class="form-control"
                          required
                          placeholder="Phone No."
                        />
                      </div>

                      <div
                          class="invalid-feedback"
                          *ngIf="
                            RegisterForm.controls.Mobile.invalid &&
                            RegisterForm.controls.Mobile.touched
                          "
                        >
                          Mobile No Required
                        </div> 
                    </div>
                  </c-col>
                   <c-col lg="6">
                    <div class="mb-3">
                      <div class="input-group">
                        <span class="input-group-text">
                          <svg cIcon name="cilAddressBook"></svg>
                        </span>
                        <input
                          type="text"
                          id="JobbTitle"
                          name="JobTitle"
                          [(ngModel)]=""
                          class="form-control"
                          required
                          placeholder="Company Name"
                        />
                      </div>
                      <div
                        class="invalid-feedback"
                        *ngIf="RegisterForm.control.hasError('passwordMismatch')"
                      >
                        <label>Password and Confirm Password do not match. *</label>
                      </div>
                    </div>
                  </c-col> 
                </c-row> -->
      <!-- <c-row>
                  <c-col lg="6">
                    <div class="mb-3">
                      <div class="input-group">
                        <span class="input-group-text">
                          <svg cIcon name="cilLockLocked"></svg>
                        </span>
                        <input
                          type="{{ showPassword ? 'text' : 'password' }}"
                          id="Password"
                          name="Password"
                          [(ngModel)]="UsersService.UserData.password"
                          class="form-control"
                          autoComplete="new-password"
                          required
                          placeholder="Password"
                          cFormControl
                          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*^#?&.(=)+-\s])([A-Za-z\d@$!%*^#?&.(=)+-\s]{8,})$"
                          title="Hint: Minimum 8 characters i.e Lower & Upper case, Numbers and Special characters"
                        />

                        <button
                          type="button"
                          class="btn btn-light"
                          (click)="togglePasswordVisibility()"
                        >
                          <img
                            cIcon
                            [src]="
                              showPassword
                                ? 'assets/images/avatars/hide.png'
                                : 'assets/images/avatars/show.png'
                            "
                          />
                        </button>
                      </div>
                      <div
                        class="text-danger"
                        style="font-size: 12px"
                        *ngIf="
                          RegisterForm?.controls?.Password?.invalid &&
                          RegisterForm?.controls?.Password?.touched
                        "
                      >
                        Password must contain at least 8 characters including
                        lowercase and uppercase letters, numbers, and special
                        characters.
                      </div>

                      
                    </div>
                  </c-col>
                  <c-col lg="6">
                    <div class="mb-3">
                      <div class="input-group">
                        <span class="input-group-text">
                          <svg cIcon name="cilLockLocked"></svg>
                        </span>
                        <input
                          type="{{ showPassword ? 'text' : 'password' }}"
                          id="ConfirmPassword"
                          name="ConfirmPassword"
                          class="form-control"
                          autoComplete="new-ConfirmPassword"
                          required
                          [(ngModel)]="confirmPassword"
                          #confirmPasswordField="ngModel"
                          pattern="{{ UsersService.UserData.password }}"
                          placeholder="Confirm Password"
                        />
                        <button
                          type="button"
                          class="btn btn-light"
                          (click)="togglePasswordVisibility()"
                        >
                          <img
                            cIcon
                            [src]="
                              showPassword
                                ? 'assets/images/avatars/hide.png'
                                : 'assets/images/avatars/show.png'
                            "
                          />
                        </button>
                      </div>
                      <div
                        class="text-danger"
                        style="font-size: 12px"
                        *ngIf="
                          RegisterForm?.controls?.ConfirmPassword?.errors
                            ?.pattern
                        "
                      >
                        Passwords must match.
                      </div>
                      
                    </div>
                  </c-col>
                </c-row> -->

      <c-row>
        <c-col lg="12">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilLocationPin"></svg>
              </span>
              <input
                type="text"
                id="StreetAddress"
                name="StreetAddress"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.addr_Street"
                placeholder="Street Address"
              />
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.StreetAddress.invalid &&
                          RegisterForm.controls.StreetAddress.touched
                        "
                      >
                        Street Address is Required
                      </div> -->
          </div>
        </c-col>
      </c-row>
      <c-row>
        <c-col lg="12">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilLocationPin"></svg>
              </span>
              <input
                type="text"
                id="City"
                name="City"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.addr_City"
                placeholder="City"
              />
              <input
                type="text"
                id="StateProvince"
                name="StateProvince"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.addr_State"
                placeholder="State/Province"
              />
              <input
                type="text"
                id="PostalZIPCode"
                name="PostalZIPCode"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserExtraInfoData.addr_ZipCode"
                placeholder="Postal/ZIP Code"
              />
              <select
                id="Country"
                name="Country"
                class="form-control"
                [(ngModel)]="UsersService.UserExtraInfoData.addr_Country"
                required
              >
                <option value="" disabled selected>Country</option>
                <option value="USA">USA</option>
                <option value="Canada">Canada</option>
                 
                <option value="Afghanistan">Afghanistan</option>
<option value="Albania">Albania</option>
<option value="Algeria">Algeria</option>
<option value="Andorra">Andorra</option>
<option value="Angola">Angola</option>
<option value="Antigua and Barbuda">Antigua and Barbuda</option>
<option value="Argentina">Argentina</option>
<option value="Armenia">Armenia</option>
<option value="Australia">Australia</option>
<option value="Austria">Austria</option>
<option value="Azerbaijan">Azerbaijan</option>
<option value="Bahamas">Bahamas</option>
<option value="Bahrain">Bahrain</option>
<option value="Bangladesh">Bangladesh</option>
<option value="Barbados">Barbados</option>
<option value="Belarus">Belarus</option>
<option value="Belgium">Belgium</option>
<option value="Belize">Belize</option>
<option value="Benin">Benin</option>
<option value="Bhutan">Bhutan</option>
<option value="Bolivia">Bolivia</option>
<option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
<option value="Botswana">Botswana</option>
<option value="Brazil">Brazil</option>
<option value="Brunei">Brunei</option>
<option value="Bulgaria">Bulgaria</option>
<option value="Burkina Faso">Burkina Faso</option>
<option value="Burundi">Burundi</option>
<option value="Cambodia">Cambodia</option>
<option value="Cameroon">Cameroon</option>
<option value="Canada">Canada</option>
<option value="Cape Verde">Cape Verde</option>
<option value="Central African Republic">Central African Republic</option>
<option value="Chad">Chad</option>
<option value="Chile">Chile</option>
<option value="China">China</option>
<option value="Colombia">Colombia</option>
<option value="Comoros">Comoros</option>
<option value="Congo">Congo</option>
<option value="Costa Rica">Costa Rica</option>
<option value="Croatia">Croatia</option>
<option value="Cuba">Cuba</option>
<option value="Cyprus">Cyprus</option>
<option value="Czech Republic">Czech Republic</option>
<option value="Denmark">Denmark</option>
<option value="Djibouti">Djibouti</option>
<option value="Dominica">Dominica</option>
<option value="Dominican Republic">Dominican Republic</option>
<option value="Ecuador">Ecuador</option>
<option value="Egypt">Egypt</option>
<option value="El Salvador">El Salvador</option>
<option value="Equatorial Guinea">Equatorial Guinea</option>
<option value="Eritrea">Eritrea</option>
<option value="Estonia">Estonia</option>
<option value="Eswatini">Eswatini</option>
<option value="Ethiopia">Ethiopia</option>
<option value="Fiji">Fiji</option>
<option value="Finland">Finland</option>
<option value="France">France</option>
<option value="Gabon">Gabon</option>
<option value="Gambia">Gambia</option>
<option value="Georgia">Georgia</option>
<option value="Germany">Germany</option>
<option value="Ghana">Ghana</option>
<option value="Greece">Greece</option>
<option value="Grenada">Grenada</option>
<option value="Guatemala">Guatemala</option>
<option value="Guinea">Guinea</option>
<option value="Guyana">Guyana</option>
<option value="Haiti">Haiti</option>
<option value="Honduras">Honduras</option>
<option value="Hungary">Hungary</option>
<option value="Iceland">Iceland</option>
<option value="India">India</option>
<option value="Indonesia">Indonesia</option>
<option value="Iran">Iran</option>
<option value="Iraq">Iraq</option>
<option value="Ireland">Ireland</option>
<option value="Israel">Israel</option>
<option value="Italy">Italy</option>
<option value="Jamaica">Jamaica</option>
<option value="Japan">Japan</option>
<option value="Jordan">Jordan</option>
<option value="Kazakhstan">Kazakhstan</option>
<option value="Kenya">Kenya</option>
<option value="Kuwait">Kuwait</option>
<option value="Kyrgyzstan">Kyrgyzstan</option>
<option value="Laos">Laos</option>
<option value="Latvia">Latvia</option>
<option value="Lebanon">Lebanon</option>
<option value="Lesotho">Lesotho</option>
<option value="Liberia">Liberia</option>
<option value="Libya">Libya</option>
<option value="Liechtenstein">Liechtenstein</option>
<option value="Lithuania">Lithuania</option>
<option value="Luxembourg">Luxembourg</option>
<option value="Madagascar">Madagascar</option>
<option value="Malawi">Malawi</option>
<option value="Malaysia">Malaysia</option>
<option value="Maldives">Maldives</option>
<option value="Mali">Mali</option>
<option value="Malta">Malta</option>
<option value="Mauritania">Mauritania</option>
<option value="Mauritius">Mauritius</option>
<option value="Mexico">Mexico</option>
<option value="Moldova">Moldova</option>
<option value="Monaco">Monaco</option>
<option value="Mongolia">Mongolia</option>
<option value="Montenegro">Montenegro</option>
<option value="Morocco">Morocco</option>
<option value="Mozambique">Mozambique</option>
<option value="Myanmar">Myanmar</option>
<option value="Namibia">Namibia</option>
<option value="Nepal">Nepal</option>
<option value="Netherlands">Netherlands</option>
<option value="New Zealand">New Zealand</option>
<option value="Nicaragua">Nicaragua</option>
<option value="Niger">Niger</option>
<option value="Nigeria">Nigeria</option>
<option value="North Korea">North Korea</option>
<option value="North Macedonia">North Macedonia</option>
<option value="Norway">Norway</option>
<option value="Oman">Oman</option>
<option value="Pakistan">Pakistan</option>
<option value="Panama">Panama</option>
<option value="Papua New Guinea">Papua New Guinea</option>
<option value="Paraguay">Paraguay</option>
<option value="Peru">Peru</option>
<option value="Philippines">Philippines</option>
<option value="Poland">Poland</option>
<option value="Portugal">Portugal</option>
<option value="Qatar">Qatar</option>
<option value="Romania">Romania</option>
<option value="Russia">Russia</option>
<option value="Rwanda">Rwanda</option>
<option value="Saudi Arabia">Saudi Arabia</option>
<option value="Senegal">Senegal</option>
<option value="Serbia">Serbia</option>
<option value="Singapore">Singapore</option>
<option value="Slovakia">Slovakia</option>
<option value="Slovenia">Slovenia</option>
<option value="South Africa">South Africa</option>
<option value="South Korea">South Korea</option>
<option value="Spain">Spain</option>
<option value="Sri Lanka">Sri Lanka</option>
<option value="Sudan">Sudan</option>
<option value="Sweden">Sweden</option>
<option value="Switzerland">Switzerland</option>
<option value="Syria">Syria</option>
<option value="Taiwan">Taiwan</option>
<option value="Tajikistan">Tajikistan</option>
<option value="Tanzania">Tanzania</option>
<option value="Thailand">Thailand</option>
<option value="Tunisia">Tunisia</option>
<option value="Turkey">Turkey</option>
<option value="Uganda">Uganda</option>
<option value="Ukraine">Ukraine</option>
<option value="United Arab Emirates">United Arab Emirates</option>
<option value="United Kingdom">United Kingdom</option>
<option value="United States">United States</option>
<option value="Uruguay">Uruguay</option>
<option value="Uzbekistan">Uzbekistan</option>
<option value="Venezuela">Venezuela</option>
<option value="Vietnam">Vietnam</option>
<option value="Yemen">Yemen</option>
<option value="Zambia">Zambia</option>
<option value="Zimbabwe">Zimbabwe</option>

              </select>
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.StreetAddress.invalid &&
                          RegisterForm.controls.StreetAddress.touched
                        "
                      >
                        Street Address is Required
                      </div> -->
          </div>
        </c-col>
      </c-row>

      <!-- <c-row>
                  <div class="text-start">
                    <h5 class="text-medium-emphasis">
                      Additional Information (Required for Issuing NFR License)
                    </h5>
                  </div>
                </c-row> -->
      <c-row>
        <div class="text-start">
          <b class="text-medium-emphasis">Contact Information</b>
        </div>
      </c-row>
      <c-row>
        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilUser"></svg>
              </span>
              <input
                type="text"
                id="firstName"
                name="firstName"
                [(ngModel)]="UsersService.UserData.firstName"
                class="form-control"
                required
                placeholder="First Name"
              />
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.FullName.invalid &&
                          RegisterForm.controls.FullName.touched
                        "
                      >
                        Full Name Required
                      </div> -->
          </div>
        </c-col>

        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg cIcon name="cilUser"></svg>
              </span>

              <input
                type="text"
                id="lastName"
                name="lastName"
                [(ngModel)]="UsersService.UserData.lastName"
                class="form-control"
                required
                placeholder="Last Name"
              />
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.FullName.invalid &&
                          RegisterForm.controls.FullName.touched
                        "
                      >
                        Full Name Required
                      </div> -->
          </div>
        </c-col>

        <!-- <c-col lg="6">
                      <div class="mb-3">
                        <div class="input-group">
                          <span class="input-group-text">
                            <svg cIcon name="cilUser"></svg>
                          </span>
                          <input
                            type="text"
                            id="userName"
                            name="userName"
                            [(ngModel)]="userService.AddUserData.loginID"
                            class="form-control"
                            autoComplete="username"
                            required
                            (focusout)="
                              checkUserName($event.target.value, true, RegisterForm)
                            "
                            placeholder="Preferred Username"
                          />
                        </div>
                        <div
                          class="text-danger"
                          style="font-size: 12px"
                          *ngIf="RegisterForm.controls.userName.errors?.usernameExists"
                        >
                          Username Already Exist
                        </div>
                      </div>
                    </c-col> -->

        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text"> &#64; </span>
              <input
                type="email"
                id="email"
                name="email"
                [(ngModel)]="UsersService.UserData.emailAddress"
                class="form-control"
                autoComplete="email"
                required
                placeholder="Email"
                pattern="^[^@\s]+@[^@\s]+\.[^@\s]+$"
                (focusout)="checkUserName($event.target.value, RegisterForm)"
              />
            </div>
            <div
              class="text-danger"
              style="font-size: 12px"
              *ngIf="EmailExists"
            >
              Email Already Exist
            </div>
            <div
              *ngIf="
                RegisterForm?.controls?.email?.invalid &&
                RegisterForm?.controls?.email?.dirty &&
                !RegisterForm.controls.email?.errors?.EmailExists
              "
              class="text-danger"
              style="font-size: 12px"
            >
              Email is required and must be in a valid format.
            </div>
          </div>
        </c-col>

        <c-col lg="6">
          <div class="mb-3">
            <div class="input-group">
              <span class="input-group-text">
                <svg [cIcon]="icons.cilPhone"></svg>
              </span>
              <input
                type="text"
                id="uPhoneNumber"
                name="uPhoneNumber"
                pattern="^[0-9\s\(\)\+\-]+$"
                (keypress)="validatePhoneNumberInput($event)"
                class="form-control"
                required
                [(ngModel)]="UsersService.UserData.mobilePhoneNumber"
                placeholder="Phone Number"
              />
            </div>
            <!-- <div
                        class="invalid-feedback"
                        *ngIf="
                          RegisterForm.controls.PhoneNumber.invalid &&
                          RegisterForm.controls.PhoneNumber.touched
                        "
                      >
                        Phone Number is Required
                      </div> -->
          </div>
        </c-col>
        <!-- <c-col lg="4">
                    <div class="mb-3">
                      <div class="input-group">
                        <input
                          cFormControl
                          #imageField
                          id="UserImage"
                          name="UserImage"
                          type="file"
                          (change)="onFileSelected($event)"
                          [cPopover]="popoverHtml"
                          cPopoverPlacement="right"
                          [cPopoverTrigger]="'hover'"
                        />
                        <ng-template #popoverHtml>
                          <div class="popover-body">
                            <div
                              class="text-center"
                              style="width: 10vw; height: 10vh"
                              *ngIf="fileSelected"
                            >
                              <img
                                cImg
                                rounded
                                [src]="imageSrc"
                                alt="Slider Image"
                                class="img-fluid"
                                width="100%"
                                height="100%"
                                style="object-fit: contain"
                              />
                            </div>
                            <div
                              class="text-center"
                              style="width: 10vw; height: 10vh"
                              *ngIf="
                                !fileSelected && UsersService.UserData.picture
                              "
                            >
                              <img
                                cImg
                                rounded
                                [src]="
                                  baseService.PRODUCTIMAGESURL +
                                  UsersService.UserData.picture
                                "
                                alt="Slider Image"
                                class="img-fluid"
                                width="100%"
                                height="100%"
                                style="object-fit: contain"
                              />
                            </div>
                            <div
                              class="text-center"
                              style="width: 10vw; height: 10vh"
                              *ngIf="
                                !fileSelected && !UsersService.UserData.picture
                              "
                            >
                              <p>Image not Selected</p>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </c-col> -->



                  <c-col lg="12">
                    <div class="mb-3">

                      <div class="input-group">
                        <span class="input-group-text">
                          <svg cIcon name="cilLockLocked"></svg>
                        </span>
                        <input
                          cFormControl
                          id="Password"
                          name="Password"
                          required
                          type="{{ showPassword ? 'text' : 'password' }}"
                          pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*^#?&.(=)+-\s])([A-Za-z\d@$!%*^#?&.(=)+-\s]{8,})$"
                          title="Hint: Minimum 8 characters i.e Lower & Upper case, Numbers and Special characters"
                          [(ngModel)]="UsersService.UserData.password"
                          placeholder="Password"
                        />
                        <button
                          type="button"
                          class="btn btn-light"
                          (click)="togglePasswordVisibility()"
                        >
                          <img
                            cIcon
                            [src]="
                              showPassword
                                ? 'assets/images/avatars/hide.png'
                                : 'assets/images/avatars/show.png'
                            "
                          />
                        </button>
                        <button
                          class="btn btn-light"
                          type="button"
                          (click)="generatePassword()"
                        >
                          Generate
                        </button>
                        <c-form-feedback [valid]="false"
                          >Password is Required and must contain at least 8 characters
                          including lowercase and uppercase letters, numbers, and special
                          characters.</c-form-feedback
                        >
                      </div>
                      <span style="font-size: 11px; color: #727272"
            >Hint: Minimum 8 characters i.e Lower & Upper case, Numbers and
            Special characters</span>
                    </div>
                  </c-col>

      </c-row>


      <div *ngIf="msg">
        <div>{{ msg }}</div>
      </div>
      <div class="text-center">
        <button
          type="submit"
          class="btn btn-primary px-4 mb-3 mt-2"
          style="margin: auto"
          [disabled]="ButtonLoading"
        >
          <c-spinner
            aria-hidden="true"
            size="sm"
            *ngIf="ButtonLoading"
          ></c-spinner>
          Create Account
        </button>
      </div>

      <!-- <div class="text-end" style="font-size: 14px; margin: 0">
        <p>
          <a routerLink="/login">Already have an account?</a>
        </p>
      </div> -->
    </form>
  </c-modal-body>
</c-modal>
